// extracted by mini-css-extract-plugin
export default {"convincingContainer":"Convincing_convincingContainer__8kJs9"};